import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster, toast } from "sonner";
import { Check } from "lucide-react";

import { EmailCaptureProvider } from "./components/EmailCaptureProvider";
import { Header } from "./sections/Header";
import { Hero } from "./sections/Hero";
import { HowItWorks } from "./sections/HowItWorks";
import { Comparison } from "./sections/Comparison";
import { Benefits } from "./sections/Benefits";
import { Ingredients } from "./sections/Ingredients";
import { Testimonials } from "./sections/Testimonials";
import { FAQ } from "./sections/FAQ";
import { ScientificReferences } from "./sections/ScientificReferences";
import { Footer } from "./sections/Footer";
import { StickyBottomBar } from "./sections/StickyBottomBar";

// Pages
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import RefundPolicy from "./pages/RefundPolicy";
import Contact from "./pages/Contact";

// Purchase Notification Hook
const usePurchaseNotifications = () => {
  useEffect(() => {
    const names = ["Sarah", "Michael", "Jennifer", "David", "Emily", "James", "Maria", "Robert", "Linda", "William", "Tasha", "Neil", "Elizabeth", "Mark", "Susan"];
    const states = ["TX", "CA", "FL", "NY", "AZ", "CO", "GA", "NC", "OH", "WA", "OR", "PA", "IL", "MI", "VA"];
    const bottles = [3, 6, 6, 3, 6, 6, 6, 3, 6, 3, 6];

    const showNotification = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomState = states[Math.floor(Math.random() * states.length)];
      const randomBottles = bottles[Math.floor(Math.random() * bottles.length)];
      const timeAgo = Math.floor(Math.random() * 3) + 1;

      toast.success(
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-[#E8F5E9] flex items-center justify-center flex-shrink-0">
            <Check size={20} className="text-[#2E7D32]" />
          </div>
          <div>
            <p className="font-bold text-[#1A1C19] text-sm">{randomName} from {randomState}</p>
            <p className="text-xs text-[#73786F]">Just ordered {randomBottles} bottles • {timeAgo} min ago</p>
          </div>
        </div>,
        {
          duration: 4000,
          position: "bottom-left",
        }
      );
    };

    const initialTimer = setTimeout(showNotification, 8000);
    const interval = setInterval(() => {
      showNotification();
    }, Math.random() * 20000 + 20000);

    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
};

// Home Page Component
const HomePage = () => {
  usePurchaseNotifications();

  return (
    <EmailCaptureProvider>
      <div className="App">
        <Toaster richColors />
        <Header />
        <main role="main">
          <article>
            <Hero />
            <HowItWorks />
            <Benefits />
            <Comparison />
            <Testimonials />
            <Ingredients />
            <FAQ />
            <ScientificReferences />
          </article>
        </main>
        <Footer />
        <StickyBottomBar />
      </div>
    </EmailCaptureProvider>
  );
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Router>
  );
}

export default App;
